module.exports = __webpack_public_path__ + "static/media/Pavers-England-Logo.2800f403.jpg";